export default {
  more: '更多',
  add: '新增',
  modify: '编辑',
  delete: '删除',
  manual: '手动获取',
  print: '打印',
  export: '导出',
  import: '导入',
  nullify: '作废',
  addASN: '新增ASN',
  submitted: '全部提交',
  hand: '批量受理',
  grant: '批量发放',
  batchok: '批量同意',
  batchno: '批量拒绝',
  issueAnInvoice: '开具发票'
}
